import { render, staticRenderFns } from "./casting-aside.vue?vue&type=template&id=394f8967&scoped=true&"
import script from "./casting-aside.vue?vue&type=script&lang=ts&"
export * from "./casting-aside.vue?vue&type=script&lang=ts&"
import style0 from "./casting-aside.vue?vue&type=style&index=0&id=394f8967&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394f8967",
  null
  
)

export default component.exports